import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Carousel.css';

const images = [
  '/images/ca.png',
  '/images/carousal.png',
  '/images/caro.png',
  '/images/carou.png',
];

const Carousel = () => {
  const [current, setCurrent] = useState(0);
  const length = images.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <img src="/images/ca.png" alt="Top" className="carousel-image" />
      <div className="carousel-container stylish-carousel">
        <button className="carousel-btn left" onClick={prevSlide}>
          <FaChevronLeft />
        </button>
        <div className="carousel-slide">
          <img src={images[current]} alt={`slide-${current}`} className="carousel-image" />
        </div>
        <button className="carousel-btn right" onClick={nextSlide}>
          <FaChevronRight />
        </button>
        <div className="carousel-indicators">
          {images.map((_, idx) => (
            <span
              key={idx}
              className={`indicator ${idx === current ? 'active' : ''}`}
              onClick={() => setCurrent(idx)}
            />
          ))}
        </div>
      </div>
      <img src="/images/carou.png" alt="Bottom" className="carousel-image" />
    </div>
  );
};

export default Carousel;
